import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-responsive-popup',
  templateUrl: './responsive-popup.component.html',
  styleUrls: ['./responsive-popup.component.less']
})
export class ResponsivePopupComponent implements OnInit {
   @Input() caption!: string;
   @Input() size? = 'large'
   @Input() headerDecoration = false;
   @Input() color: 'yellow' | 'orange' = 'yellow';
  constructor() { }

  ngOnInit(): void {

  }

}
